import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=5c1bd680&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=ts&"
export * from "./InfoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=5c1bd680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1bd680",
  null
  
)

export default component.exports